export default "__VITE_ASSET__l5D8wpXN__"